<lbca-message-feedback
	[show]="messageFeedObject.show"
	[type]="messageFeedObject.type"
	[autoclose]="messageFeedObject.autoclose"
	(closeFeed)="closeFeed()"
	[emoji]="messageFeedObject.emoji"
>
	<li messagePrimary>{{ messageFeedObject.primary }}</li>
	<li messageSecondary>{{ messageFeedObject.secondary }}</li>
</lbca-message-feedback>

<section class="inline-flex w-full mb-[40px]">
	<lbca-icon
		name="lucide:move-left"
		class="text-primary mt-[15px] mr-[15px]"
		(click)="closeModal()"
	></lbca-icon>

	<div class="w-[60%]">
		@for (editText of msgEditClaim; track editText) {
			<p class="text-2xl highlightEven">{{ editText }}</p>
		}
	</div>
	@if (editPhase) {
		<div class="flex flex-col">
			@if (editPhase.label !== currentLegalRequest.label) {
				<div class="text-xs text-font ml-[25px]">
					{{ claimLabelsDict['other-phase'] }}
				</div>
			}
			@if (editPhase.label === currentLegalRequest.label) {
				<div class="text-xs text-font ml-[25px]">
					{{ claimLabelsDict['actual-phase'] }}
				</div>
			}
			<div>
				<button
					type="button"
					class="btn-type-4 ml-[25px]"
					[class.danger]="editPhase.label !== currentLegalRequest.label"
					[class.primary]="editPhase.label === currentLegalRequest.label"
				>
					{{ editPhase.label }}
				</button>
			</div>
		</div>
	}
</section>

@if (loadPage) {
	<section class="form-fields-sub-module-modal">
		<lbca-table-secondary
			[table]="tableEdit"
			[disabled]="disabled"
			[saveOnChange]="false"
			[openExpanded]="true"
			[enableCheckItens]="false"
			(changeValue)="changeValueEdit($event)"
			[cardData]="cardInfo"
		></lbca-table-secondary>
	</section>
}

<section class="flex mt-[40px] absolute bottom-[30px]">
	<button type="button" class="btn-secondary btn-type-2 ml-[4px]" (click)="closeModal()">
		{{ claimLabelsDict['btn-cancel'] }}
	</button>
	<button
		type="button"
		class="btn-primary btn-type-2 ml-[25px] load-action"
		[class.btn-motion-bg-gray-100]="submitButtonEditClaim"
		[disabled]="submitButtonEditClaim"
		(click)="editLegalRequest($event)"
	>
		@if (!submitButtonEditClaim) {
			{{ claimLabelsDict['btn-edit-claim'] }}
		}
		@if (submitButtonEditClaim) {
			<img class="forgot-loading" src="./assets/icons/loading-points-bg-primary.svg" />
		}
	</button>
</section>
